<div class="outer-container">
    <div class="close-icon-container">
        <img class="cursor-pointer" src="./images/close.svg" (click)="close()">
    </div>
    <div class="logo-container">
        <img src="./images/raees.svg">
    </div>
    <div class="content">
        {{modalData.content | translate}}
    </div>
    <div class="navigation-links-container">
        <img class="apple-store cursor-pointer" (click)="appleStoreNavigation()">
        <img class="google-store cursor-pointer" (click)="googleStoreNavigation()">
    </div>
</div>
